/* T8 art trim: some "artwork only" product images carry their own plain white / off-white border, which reads as a mount inside
   the card frames. For every framed artwork (.t8-artframe > img) this samples a small copy of the image, finds a plain light
   border (rows / columns that match the corner colour), and crops it away: the frame takes the trimmed artwork's ratio (--r)
   and the image is enlarged and shifted inside it (the frame clips). Same-origin /cdn/shop images only; anything else is left as is. */
(function () {
  'use strict';
  var S = 96, TOL = 22, MAX = 0.14;
  function small(src) {
    try {
      var u = new URL(src, location.href);
      if (u.origin !== location.origin) return null;
      u.searchParams.set('width', S * 2); u.searchParams.delete('height');
      return u.href;
    } catch (e) { return null; }
  }
  function box(img, cb) {
    var url = small(img.currentSrc || img.src); if (!url) return;
    var p = new Image(); p.crossOrigin = 'anonymous';
    p.onload = function () {
      var w = S, h = Math.max(8, Math.round(S * p.naturalHeight / p.naturalWidth));
      var c = document.createElement('canvas'); c.width = w; c.height = h;
      var x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(p, 0, 0, w, h);
      var d; try { d = x.getImageData(0, 0, w, h).data; } catch (e) { return; }
      function px(i, j) { var k = (j * w + i) * 4; return [d[k], d[k + 1], d[k + 2]]; }
      var corners = [px(1, 1), px(w - 2, 1), px(1, h - 2), px(w - 2, h - 2)];
      var ref = [0, 1, 2].map(function (ch) { return corners.reduce(function (s, q) { return s + q[ch]; }, 0) / 4; });
      if (ref[0] + ref[1] + ref[2] < 3 * 205) return;                     /* only light borders (white / off-white mounts) */
      if (corners.some(function (q) { return Math.abs(q[0] - ref[0]) + Math.abs(q[1] - ref[1]) + Math.abs(q[2] - ref[2]) > TOL * 2; })) return;
      function plain(q) { return Math.abs(q[0] - ref[0]) + Math.abs(q[1] - ref[1]) + Math.abs(q[2] - ref[2]) <= TOL; }
      function rowPlain(j) { var n = 0; for (var i = 0; i < w; i++) if (!plain(px(i, j))) n++; return n <= w * 0.02; }
      function colPlain(i) { var n = 0; for (var j = 0; j < h; j++) if (!plain(px(i, j))) n++; return n <= h * 0.02; }
      var t = 0, b = 0, l = 0, r = 0;
      while (t < h * MAX && rowPlain(t)) t++;
      while (b < h * MAX && rowPlain(h - 1 - b)) b++;
      while (l < w * MAX && colPlain(l)) l++;
      while (r < w * MAX && colPlain(w - 1 - r)) r++;
      if (!t || !b || !l || !r) return;                                   /* a mount runs round all four sides; a light sky or wall at one edge is artwork */
      /* a printed border frames an even background (cream / yellow / red paper): the ring just inside it is one colour, unlike
         a white-background design (letters reach the edge) or a gallery poster (a photo reaches it). Those keep their white. */
      var ring = [], ii, jj, y0 = t + 1, y1 = h - 2 - b, x0 = l + 1, x1 = w - 2 - r;
      if (x1 - x0 < 8 || y1 - y0 < 8) return;
      for (ii = x0; ii <= x1; ii += 2) { ring.push(px(ii, y0), px(ii, y1)); }
      for (jj = y0; jj <= y1; jj += 2) { ring.push(px(x0, jj), px(x1, jj)); }
      var med = [0, 1, 2].map(function (ch) { var v = ring.map(function (q) { return q[ch]; }).sort(function (a, b) { return a - b; }); return v[v.length >> 1]; });
      var even = ring.filter(function (q) { return Math.abs(q[0] - med[0]) + Math.abs(q[1] - med[1]) + Math.abs(q[2] - med[2]) <= TOL * 1.5; }).length / ring.length;
      if (even < 0.6 || plain(med)) return;
      /* one extra pixel so no light line is left at the edge */
      var k = { t: (t + 1) / h, b: (b + 1) / h, l: (l + 1) / w, r: (r + 1) / w };
      k.ratio = (p.naturalWidth * (1 - k.l - k.r)) / (p.naturalHeight * (1 - k.t - k.b));
      cb(k);
    };
    p.src = url;
  }
  function trim(img) {
    if (img.dataset.t8Trim) return; img.dataset.t8Trim = '1';
    var frame = img.closest('.t8-artframe'); if (!frame) return;
    box(img, function (k) {
      var fw = 1 - k.l - k.r, fh = 1 - k.t - k.b;
      frame.style.setProperty('--r', k.ratio.toFixed(4));
      frame.style.overflow = 'hidden';
      img.style.cssText += ';position:absolute;max-width:none;object-fit:fill;width:' + (100 / fw) + '%;height:' + (100 / fh) + '%;left:' + (-100 * k.l / fw) + '%;top:' + (-100 * k.t / fh) + '%';
    });
  }
  function scan(root) {
    (root || document).querySelectorAll('.t8-artframe > img').forEach(function (img) {
      if (img.complete && img.naturalWidth) trim(img); else img.addEventListener('load', function () { trim(img); }, { once: true });
    });
  }
  window.T8ArtTrim = { box: box };   // the product page frame preview (assets/t8-frame-preview.js) crops the same border
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); }); else scan();
  document.addEventListener('t8:cards:added', function (e) { scan(e.detail && e.detail.root); });
  if ('MutationObserver' in window) new MutationObserver(function (ms) {
    ms.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) { if (n.matches && n.matches('.t8-artframe > img')) scan(n.parentNode); else if (n.querySelector && n.querySelector('.t8-artframe > img')) scan(n); } }); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
